export const tr = {
    'campaign-group': 'Kampanya/Grup',
    'campaign-type': 'Kampanya türü',
    'context-price': 'Teklif (ağlarda)',
    'context-price-with-currency': 'Teklif (ağlarda), {currency}',
    description: 'Not',
    name: 'Ad',
    price: 'Maksimum tıklama fiyatı',
    status: 'Durum',
    targeting: 'Gösterim koşulları'
};
